import { render, staticRenderFns } from "./SaleLayouts.vue?vue&type=template&id=6f3a3f1c"
import script from "./SaleLayouts.vue?vue&type=script&lang=ts"
export * from "./SaleLayouts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3a3f1c')) {
      api.createRecord('6f3a3f1c', component.options)
    } else {
      api.reload('6f3a3f1c', component.options)
    }
    module.hot.accept("./SaleLayouts.vue?vue&type=template&id=6f3a3f1c", function () {
      api.rerender('6f3a3f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/SaleLayouts.vue"
export default component.exports